import(/* webpackMode: "eager" */ "/vercel/path0/src/app/(home)/resources/page.tsx");
